'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MessageWithFallback = require('./components/MessageWithFallback.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MessageWithFallback).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/localization-message-with-fallback/lib/index.js
// module id = 537
// module chunks = 1